import { QRFC } from "./QRFC";

export class QBoxStylesRFC extends QRFC {
  constructor() {
    super();
  }

  InitUploadBSRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qboxstyles";
  }

  SetParams(orgName, userName, mode, data) {
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];

    callBackObj.UploadBoxStylesResult(success);
  }
}
